import React, { useEffect, useRef } from "react";

function DIframe({ authUrl, callBack }) {
  const iframeRef = useRef(null);

  useEffect(() => {
    // Clear the interval when the component unmounts
    console.log("useEffect");
  }, []);

  function loadFinished() {
    console.log("finished loading");
    try {
      const iframe = iframeRef.current;
      var url = iframe.contentWindow.location.toString();
      // var url = document.getElementById("iframe").contentWindow.location.toString();
      callBack(url, null);
    } catch (error) {
      callBack(null, error);
    }
  }

  return <iframe title="invisibleFrame" ref={iframeRef} src={authUrl} onLoad={loadFinished} width="0" height="0" />;
}

export default React.memo(DIframe);
